import { c as _c } from "react/compiler-runtime";
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  className?: string;
  disabled?: boolean;
}
export default function Button(t0) {
  const $ = _c(5);
  const {
    children,
    onClick,
    variant: t1,
    className: t2,
    disabled: t3
  } = t0;
  const variant = t1 === undefined ? "primary" : t1;
  const className = t2 === undefined ? "" : t2;
  const disabled = t3 === undefined ? false : t3;
  const variantStyles = variant === "primary" ? "bg-primary text-white" : "bg-white text-black";
  const t4 = `${"w-full font-semibold py-3 rounded-xl text-base flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"} ${variantStyles} ${className}`;
  let t5;
  if ($[0] !== children || $[1] !== disabled || $[2] !== onClick || $[3] !== t4) {
    t5 = <button onClick={onClick} disabled={disabled} className={t4}>{children}</button>;
    $[0] = children;
    $[1] = disabled;
    $[2] = onClick;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}